export default function Milestones() {
  const milestones = [
    {
      year: '2020',
      title: 'TrackVerse Founded',
      description: 'Michael Ashley establishes TrackVerse in Ajaccio, France, with a vision to revolutionize global logistics through innovative tracking technology.',
      icon: 'ri-rocket-line'
    },
    {
      year: '2021',
      title: 'European Expansion',
      description: 'Expanded operations to 15 European countries, establishing key partnerships with major shipping carriers and logistics providers.',
      icon: 'ri-map-pin-line'
    },
    {
      year: '2021',
      title: 'Real-Time Tracking Launch',
      description: 'Launched advanced real-time tracking system supporting all transport modes: road, sea, air, and rail with live GPS integration.',
      icon: 'ri-radar-line'
    },
    {
      year: '2022',
      title: 'Global Network Achieved',
      description: 'Reached milestone of operating in 50+ countries across 6 continents, processing over 100,000 shipments monthly.',
      icon: 'ri-global-line'
    },
    {
      year: '2022',
      title: 'AI Integration',
      description: 'Implemented AI-powered route optimization and predictive analytics, reducing delivery times by 18% and improving efficiency.',
      icon: 'ri-brain-line'
    },
    {
      year: '2023',
      title: 'Sustainability Initiative',
      description: 'Launched carbon-neutral shipping options and eco-friendly logistics solutions, partnering with green transport providers.',
      icon: 'ri-leaf-line'
    },
    {
      year: '2023',
      title: '1 Million Shipments',
      description: 'Celebrated processing our 1 millionth shipment, serving over 50,000 businesses and individual customers worldwide.',
      icon: 'ri-trophy-line'
    },
    {
      year: '2024',
      title: 'Singapore Hub Opening',
      description: 'Opened state-of-the-art distribution hub in Singapore, strengthening our Asia-Pacific presence and reducing transit times.',
      icon: 'ri-building-line'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Our Journey
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From a startup vision to a global logistics leader, discover the key milestones 
            that have shaped TrackVerse's growth and success.
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-blue-200 hidden lg:block"></div>

          <div className="space-y-12">
            {milestones.map((milestone, index) => (
              <div 
                key={index}
                className={`relative flex items-center ${
                  index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                } flex-col`}
              >
                <div className={`w-full lg:w-5/12 ${index % 2 === 0 ? 'lg:text-right lg:pr-12' : 'lg:text-left lg:pl-12'}`}>
                  <div className="bg-white rounded-lg p-6 border border-gray-200 hover:shadow-lg transition-shadow">
                    <div className="flex items-center gap-3 mb-3">
                      <div className={`w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center ${index % 2 === 0 ? 'lg:ml-auto' : ''}`}>
                        <i className={`${milestone.icon} text-2xl text-blue-600`}></i>
                      </div>
                      <div className="text-2xl font-bold text-blue-600">{milestone.year}</div>
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                      {milestone.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {milestone.description}
                    </p>
                  </div>
                </div>

                <div className="hidden lg:flex absolute left-1/2 transform -translate-x-1/2 w-4 h-4 bg-blue-600 rounded-full border-4 border-white shadow-md z-10"></div>

                <div className="w-full lg:w-5/12"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
